export default __webpack_public_path__ + "static/media/system-outlined.dc384b60.svg";